import React from 'react';
import { Link } from 'react-router-dom';

import Image from '../../assets/img/team/team-2-1.png';
import shapeImg from '../../assets/img/team/shape-2-1.png';

const SingleTeamTwo = (props) => {
  const { itemClass, teamImage, authorName, specialist } = props;
  return (
    <div className={itemClass ? itemClass : 'it-team-2-item text-center'}>
      <div className="it-team-2-thumb fix p-relative mb-25">
        <img src={teamImage ? teamImage : Image} alt="" />
        <div className="it-team-2-shape-1">
          <img src={shapeImg} alt="" />
        </div>
      </div>
      <div className="it-team-2-author-box">
        <h4 className="it-team-2-title">
          <Link className="hover-anim" to="/team-details">
            {authorName ? authorName : ' Dr. Pauline W. Hamilton'}
          </Link>
        </h4>
        <p>
          {specialist
            ? specialist
            : 'FCPS (Medicine), FACP (USA)Professor & Head of Department(Ex.)Medicine Specialist'}
        </p>
      </div>
    </div>
  );
};

export default SingleTeamTwo;
